module.exports = __webpack_public_path__ + "static/media/Upload screen.842d48fc.png";